<template>
	<span class="warn pointer" @click="fnEdit">
		<b>{{ node.name }}:</b>
		<p class="message">{{ node.errors[0] }}</p>
	</span>
</template>

<style scoped>
.warn {
	color: var(--v-rust-red-base);
}

.pointer {
	cursor: pointer;
}
</style>

<script>
export default {
	props: {
		node: {
			type: Object,
			required: true,
		},

		fnEdit: {
			type: Function,
			default: () => () => {}
		}
	},
};
</script>
